import { addDays, addHours, differenceInDays, format, set } from "date-fns";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
//import { ConfirmDialog } from "primereact/confirmdialog"
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
//import { ProgressSpinner } from "primereact/progressspinner";
import classNames from "classnames";
import { Calendar } from "primereact/calendar";
import { Divider } from "primereact/divider";
import { RadioButton } from "primereact/radiobutton";
import { SelectButton } from "primereact/selectbutton";
import React, { useEffect, useState } from "react";
import { FaCalendarAlt, FaChartPie, FaCheckDouble, FaChevronCircleDown, FaDownload, FaEquals, FaFilePdf, FaHandshake, FaMinusCircle, FaPlusCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import { Api } from "../../../services/api";
import { associado_id, userInfo } from "../../../services/authHandlers";
import { CalendarPague, DropdownPague, InputNumberPague } from "../../../styles/primeReactConfig";
import Base64ToPDF from "../../../utils/Base64ToPDF";
import { formatCurrency } from "../../../utils/formatCurrency";
import ConfirmNegotiateDialog from "./confirmaNegociar";


export const NegotiateDialog = ({ rowInfo, close, refresh }) => {

  const [total, setTotal] = useState(0);
  const [first, setFirst] = useState(0);
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);
  const [, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [tipoNegociacao, setTipoNegociacao] = useState('total')
  const [cobrancasSelecionadas, setCobrancasSelecionadas] = useState([]);
  const [cobrancasTabela, setCobrancasTabela] = useState([]);
  const [dadosTabela, setDadosTabela] = useState([]);
  const [valorOriginal, setValorOriginal] = useState(0);
  const [valorJuros, setValorJuros] = useState(0);
  const [valorMulta, setValorMulta] = useState(0);
  const [valorIndice, setValorIndice] = useState(0);
  const [valorCorrigido, setValorCorrigido] = useState(0);
  const [valorFeeProtesto, setValorFeeProtesto] = useState(0);
  const [valorFeeProtestoDesconto, setValorFeeProtestoDesconto] = useState(0);
  const [valorTotal, setValorTotal] = useState(0);
  const [valorComDesconto, setValorComDesconto] = useState(0);
  const [valorTaxaEnvioProtesto, setTaxaEnvioProtesto] = useState(0);
  const [protestoPrimeiraParcela, setProtestoPrimeiraParcela] = useState(false);
  const [valorParcela, setValorParcela] = useState(0);
  const [valorAPagar, setValorAPagar] = useState(0);
  const [valorEntrada, setValorEntrada] = useState(0);
  const [valorFeeEntrada, setValorFeeEntrada] = useState(0);
  const [taxaPagueEntrada, setTaxaPagueEntrada] = useState(0);
  const [taxaPague, setTaxaPague] = useState(0);
  const [desconto, setDesconto] = useState(null);
  const [maxDesconto, setMaxDesconto] = useState(0)
  const [porcentagemDesconto, setPorcentagemDesconto] = useState(null);
  const [tipoFee, setTipoFee] = useState('')
  const [juros, setJuros] = useState(true);
  const [multa, setMulta] = useState(true);
  const [indice, setIndice] = useState(true);
  const [original, setOriginal] = useState(true);
  const [porcentagem, setPorcentagem] = useState(false);
  const [vencimentoBoleto, setVencimentoBoleto] = useState(1);
  const [reset, setReset] = useState(false);
  const [negotiateInfo, setNegotiateInfo] = useState([]);
  const [mostraConfirmacao, setMostraConfirmacao] = useState(false);
  const [negociar, setNegociar] = useState(false);
  const [termoBase64, setTermoBase64] = useState(null);
  const [mostraDownloadBoleto, setMostraDownloadBoleto] = useState(false)
  const [boletoData, setBoletoData] = useState(false);
  const [parcela, setParcela] = useState()
  const [parcelasOpcoes] = useState(() => {

    const parcela = []
    for (let i = 1; i < 49; i++)
      parcela.push(
        { label: i.toString() + 'X', value: i }
      )
    return parcela
  })

  const botaoTipoPagamento = (option) => {
    return (
      <div className={`flex justify-between items-center gap-4 w-full ${option.className}`}>
        <h6 className="text-xl">{option.label}</h6>
        <i className="text-2xl">{option.icon}</i>
      </div>
    );
  };

  const tipoNegociacaoOptions = [
    {
      label: "Todas",
      value: "total",
      icon: <FaCheckDouble />,
    },
    {
      label: "Parcial",
      value: "parcial",
      icon: <FaChartPie />
    },
  ];

  const cobrancasColunas = [{
    field: "cobranca_descricao",
    //style: {minWidth:"20%" },
    header: "Descrição",
  },
  {
    field: "valor_pagamento_sem_desconto",
    //style: {minWidth:"15%" },
    header: "Valor Total",
    body: (rowData) => formatCurrency(rowData.valor_pagamento_sem_desconto),
  },
  {
    field: "data_vencimento",
    //style: {minWidth:"15%" },
    header: "Vencimento",
    body: (rowData) => format(addHours(new Date(rowData.data_vencimento), 3), 'dd/MM/yyyy')
  }]

  useEffect(() => {
    const carregaCobranca = async () => {
      setLoading(true)
      try {
        const { data } = await Api.get(`/cobranca/generica/${userInfo.usuario_id}/${rowInfo.usuario_id}/${limit}/${page}`)
        setTotal(data.count)
        setDadosTabela(data)
        setCobrancasTabela(data.cobrancas)
        if(tipoNegociacao === 'total')
        resetaTotal(data)
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    carregaCobranca()
  }, [rowInfo, reload])

  useEffect(() => {
    calculaDescontoPorcentagem(porcentagemDesconto)
  }, [reset])

  const resetaTotal = (data) => { 
    setValorOriginal(data.original_total)
    setValorJuros(data.valor_juros)
    setValorMulta(data.multa_total)
    setValorIndice(data.valor_indice)
    setValorCorrigido(data.original_total + data.valor_juros + data.multa_total + data.valor_indice)
    if (data.cobrancas[0].tipo_cobranca_fee !== 'nenhum'){
      setValorFeeProtesto(data.valor_fee_s_desconto)
      setValorFeeProtestoDesconto(data.valor_fee_s_desconto)
    }
    if (data.parametrosCobrancaDesconto.protesto_primeira_parcela)
      setTaxaEnvioProtesto(data.valor_protesto_taxa_envio)
    setProtestoPrimeiraParcela(data.parametrosCobrancaDesconto.protesto_primeira_parcela)
    setValorComDesconto(data.total + data.desconto_total)
    setValorTotal(data.total + data.desconto_total)
    setTipoFee(data.cobrancas[0].tipo_cobranca_fee)
    setPorcentagemDesconto(0)
    setReset(prevState => !prevState)
  }

  const mudaSelecao = async (e) => {
    if (tipoNegociacao === "total") return false;
    setCobrancasSelecionadas(e.value);
    setValorEntrada(0);
    setValorFeeEntrada(0);
    setTaxaPagueEntrada(0);
    valoresNegociacaoParcial(e.value);
    setReset(prevState => !prevState)
    if(!porcentagem) {
      setPorcentagemDesconto(0)
    }
  }

  function valoresNegociacaoParcial(cobrancas_array) {
    if (cobrancas_array.length > 0) {
      //console.log(cobrancas_array[0].valor_original)
      const valor_parcial_original = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_original);
      }, 0);
      const valor_parcial_juros = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_juros);
      }, 0);
      const valor_parcial_multa = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_multa);
      }, 0);
      const valor_parcial_indice = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_indice);
      }, 0);
      const valor_parcial_corrigido = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_sem_fee_protesto);
      }, 0);
      const valor_parcial_fee_protesto = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_fee_protesto);
      }, 0);
      const valor_parcial_total_sem_desc = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_pagamento_sem_desconto);
      }, 0);
      const valor_parcial_total_com_desc = cobrancas_array.reduce((acc, curr) => {
        if (curr.negociacao_quebrada_id)
          return (
            acc + (Number(curr.valor_para_pagamento) - Number(curr.desconto_total) + Number(curr.valor_fee_protesto_desconto))
          )
        else
          return (
            acc + (Number(curr.valor_pagamento_com_desconto) - (Number(curr.valor_fee_protesto) - Number(curr.valor_fee_protesto_desconto)))
          );
      }, 0);
      const valor_parcial_envio_protesto = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.protesto_taxa_envio);
      }, 0);

      setValorOriginal(valor_parcial_original);
      setValorJuros(valor_parcial_juros);
      setValorMulta(valor_parcial_multa);
      setValorIndice(valor_parcial_indice);
      setValorCorrigido(valor_parcial_corrigido);
      if (tipoFee !== 'nenhum'){
        setValorFeeProtesto(valor_parcial_fee_protesto);
        setValorFeeProtestoDesconto(valor_parcial_fee_protesto);
      }
      if (protestoPrimeiraParcela)
        setTaxaEnvioProtesto(valor_parcial_envio_protesto);
      setValorComDesconto(valor_parcial_total_com_desc);
      setValorTotal(valor_parcial_total_sem_desc);
      // console.log(valor_parcial_total_com_desc)
    } else {
      setValorOriginal(0);
      setValorJuros(0);
      setValorMulta(0);
      setValorIndice(0);
      setValorCorrigido(0);
      setValorFeeProtesto(0);
      setValorFeeProtestoDesconto(0);
      setTaxaEnvioProtesto(0);
      setValorComDesconto(0);
      setValorTotal(0);
    }
  }

  const simulaParcelas = async (e) => {
    setParcela(e)
    setLoading(true)
    try {
      if (valorEntrada > 0) {
        const response_entrada = await Api.get(`/parcelamentos/listv2/credor/${valorEntrada}/B/1/${rowInfo.usuario_id}/${userInfo.usuario_id}/visa`)
        let valor_pague_entrada = 0
        if (response_entrada?.data.length > 0) {
          const valor_entrada_total = Number(response_entrada?.data[response_entrada?.data.length - 1].valor_parcela)
          valor_pague_entrada = valor_entrada_total - valorEntrada
          // console.log(valor_pague_entrada)
          setTaxaPagueEntrada(valor_pague_entrada)
        }
        const { data } = await Api.get(`/parcelamentos/listv2/credor/${valorComDesconto - valorEntrada}/B/${e}/${rowInfo.usuario_id}/${userInfo.usuario_id}/visa`)
        if (data.length > 0) {
          const valor_parcela = Number(data[data.length - 1].valor_parcela)
          const valor_pagamento = (Number(e) * valor_parcela) + valorEntrada + valor_pague_entrada
          setValorParcela(valor_parcela)
          setTaxaPague(valor_pagamento - valorComDesconto)
          setValorAPagar(valor_pagamento)
        }
        else
          console.log("ERRO")
      } else {
        const { data } = await Api.get(`/parcelamentos/listv2/credor/${valorComDesconto}/B/${e}/${rowInfo.usuario_id}/${userInfo.usuario_id}/visa`)
        if (data.length > 0) {
          const valor_parcela = Number(data[data.length - 1].valor_parcela)
          const valor_pagamento = (Number(e) * valor_parcela)
          setValorParcela(valor_parcela)
          setTaxaPague(valor_pagamento - valorComDesconto)
          setValorAPagar(valor_pagamento)
        }
        else
          console.log("ERRO")
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  function criaPagamentoData() {
    const PAYMENT_METHOD_QUANTITY = 1;
    const
      [{ cobranca_id }]
        = cobrancasTabela;
    return {
      array_cobrancas: tipoNegociacao === 'parcial' ? cobrancasSelecionadas : [],
      cobranca_id,
      parcelas: parcela + (valorEntrada > 0 ? 1 : 0),
      tipo: 'boleto',
      cobranca_qtd_meio_pagamento: PAYMENT_METHOD_QUANTITY,
      valor: (valorComDesconto - valorTaxaEnvioProtesto).toFixed(2),
      token_card: "",
      fee_direto: 1,
      tipo_fee: valorFeeProtestoDesconto,
      fee_pague: taxaPague.toFixed(2),
      cartao_bandeira: null,
      dia_vencimento_boleto: vencimentoBoleto,
      taxa_envio_protesto: valorTaxaEnvioProtesto,
      origem: 'NEGOCIA CLIENTE',
      entrada: valorEntrada.toFixed(2),
      entrada_fee: valorFeeEntrada.toFixed(2),
      tipo_negociacao: tipoNegociacao
    };
  }

  function logData(negociacao_id) {
    return {
      cobranca_id: negociacao_id,
      credor_id: userInfo.usuario_id,
      action: 'Negociação feita pelo credor',
      id_usuario: associado_id,
      othervalue: rowInfo.usuario_documento,
    };
  }

  const criaNegociacao = async () => {

    try {
      const dataPagamento = criaPagamentoData();
      //console.log(dataPagamento)
      const { data } = await
        toast.promise(Api.post(
          "/genericnegotiation/create",
          dataPagamento
        ),
          {
            pending: 'Gerando boleto',
            success: 'Sua negociação foi gerada com sucesso! Baixe o primeiro boleto agora',
            error: 'Erro ao gerar boleto, tente novamente mais tarde'
          }
        );
      setBoletoData(data[0])
      try {
        await Api.post('log/login', logData(data[0].negociacao_id))
        console.log('Log de negociação criado com sucesso')
      } catch (error) {
        console.log(error)
      }
      setLoading(false)
      setReload(prevState => !prevState)
      refresh()
      //toast.success("Sua negociação foi gerada com sucesso! Baixe o primeiro boleto agora")
      setMostraDownloadBoleto(true)
      return (data[0].id)
      //console.log(data)
    } catch (error) {
      setLoading(false);
      //toast.error('Erro ao gerar boleto, tente novamente mais tarde');
      console.log(error);
      return null
    }
  }

  const criaTermo = async () => {
    const termo_body = {
      devedor_id: rowInfo.usuario_id,
      credor_id: userInfo.usuario_id,
      qt_parcelas: (parcela + (valorEntrada > 0 ? 1 : 0)).toString(),
      valor_parcelas: valorParcela.toFixed(2),
      vencimento: format(addDays(new Date(), vencimentoBoleto), 'yyyy-MM-dd'),
      valor_total: valorComDesconto.toFixed(2),
      multa: '2',
      juros: '1',
      taxa_envio: valorTaxaEnvioProtesto,
      valor_entrada: (valorEntrada + taxaPagueEntrada).toFixed(2),
      tipo_negociacao: tipoNegociacao,
      cobrancas: tipoNegociacao === 'parcial' ? cobrancasSelecionadas : [],
    }
    setLoading(true)
    try {
      const { data } = await Api.post('termo/criar', termo_body)
      setTermoBase64(data.base64_pdf_termo)

      const e = await criaNegociacao()

      const termo_criar = {
        base64: data.base64_pdf_termo,
        boleto_id: e,
      };
      await Api.post('/genericTerm/create', termo_criar)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  function baixaBoleto() {
    Base64ToPDF(boletoData.boleto_base64, `1-boleto`)
  }


  function onPage(event) {
    const startIndex = parseInt(event.first);
    setLimit(event.rows);
    setPage(event.page);
    setFirst(startIndex);
    setReload((prevReload) => !prevReload);
  };

  function recalculaFeeDesconto(valor_desconto){
    const porcentagem_desconto = 1-(valor_desconto/valorCorrigido);
    const valor_fee_c_desconto = valorFeeProtesto*porcentagem_desconto;
    //console.log({porcentagem_desconto,valor_fee_c_desconto,valor_desconto,max_desconto})
    setValorFeeProtestoDesconto(valor_fee_c_desconto);
    return valor_fee_c_desconto
  }

  function calculaMaxDesconto() {
    if (tipoFee !== 'credor') {
      const max_desconto = valorOriginal * Number(original) + valorJuros * Number(juros) + valorMulta * Number(multa) + valorIndice * Number(indice);
      setMaxDesconto(max_desconto);
      return max_desconto
    } else {
      const max_desconto = valorOriginal * Number(original) + valorJuros * Number(juros) + valorMulta * Number(multa) + valorIndice * Number(indice);
      setMaxDesconto(max_desconto);
      return max_desconto
    }
  }

  function calculaDescontoPorcentagem(e) {
    const max_desconto = calculaMaxDesconto()
    const valor_desconto = e * max_desconto / 100;
    const valor_desconto_servicos = valorFeeProtesto - recalculaFeeDesconto(valor_desconto);
    const valor_com_desconto = Math.ceil((valorTotal - valor_desconto - valor_desconto_servicos)*100)
    //console.log(valor_com_desconto/100)
    setPorcentagemDesconto(e);
    setDesconto(valor_desconto);
    setValorComDesconto(Math.abs(valor_com_desconto/100));
    setParcela(0);
    setValorParcela(0);
    setValorAPagar(0);
    setTaxaPague(0);
    setTaxaPagueEntrada(0);
  }

  function calculaFeeEntrada(e) {
    const fee_proporcional = valorFeeProtesto / valorCorrigido
    const valor_fee_entrada = fee_proporcional * e
    return valor_fee_entrada
  }

  function confirmarNegociacao() {
    const data = {
      valorTotal,
      desconto: desconto + (valorFeeProtesto - valorFeeProtestoDesconto) - taxaPague,
      valorAPagar,
      valorTaxaEnvioProtesto,
      valorEntrada,
      //valorProtesto:valorFeeProtesto,
      valorPague: taxaPague + valorFeeProtestoDesconto,
      valorProvider: valorAPagar - valorFeeProtestoDesconto - taxaPague,
    }
    setNegotiateInfo(data)
    setMostraConfirmacao(true)
  }

  return (
    <Dialog
      header="Negociar Título"
      visible
      pt={{
        root: 'w-screen lg:w-[80vw] max-h-[90vh]',
        headerTitle: 'font-bold text-xl w-full text-center',
        content: ({ state }) => ({
          className: classNames('overflow-auto w-full max-h-[80vh]',
            'bg-white text-gray-700 px-6 pb-8 pt-0',
            'rounded-bl-lg rounded-br-lg',
            'dark:bg-gray-900 dark:text-white/80 ', {
            "grow": state.maximized
          })
        }),
      }}
      onHide={() => close()}
    >

      {mostraConfirmacao &&
        <ConfirmNegotiateDialog
          close={() => setMostraConfirmacao(false)}
          negotiateInfo={negotiateInfo}
          accept={() => { criaTermo(); setMostraConfirmacao(false) }}
          reject={() => setMostraConfirmacao(false)}
        />}

      <React.Fragment>
        <div className="grid grid-cols-2 w-full">
          <div className="flex flex-col z-10
        justify-center items-center cursor-pointer"
            onClick={() => { setActiveIndex(1); setNegociar(false); setReset(prevReset => !prevReset) }}
          >
            <span className={classNames(
              "rounded-full w-12 h-12 flex",
              "border-2 border-slate-200 items-center",
              "justify-center",
              {
                "bg-sky-400 text-white font-bold dark:border-slate-100": !negociar,
                "bg-white dark:bg-slate-800 dark:border-slate-500": negociar
              }
            )}>
              1
            </span>
            <p className={classNames("text-center",
              {
                "font-bold": !negociar
              }
            )}>
              Informações da Inadimplência
            </p>
          </div>
          <div className="flex flex-col z-10
        justify-center items-center cursor-pointer"
            onClick={() => { setActiveIndex(2); setNegociar(true); setReset(prevReset => !prevReset) }}
          >
            <span className={classNames(
              "rounded-full w-12 h-12 flex",
              "border-2 border-slate-200 items-center",
              "justify-center",
              {
                "bg-sky-400 text-white font-bold dark:border-slate-100": negociar,
                "bg-white dark:bg-slate-800 dark:border-slate-500": !negociar
              }
            )}>
              2
            </span>
            <p className={classNames("text-center",
              {
                "font-bold": negociar
              }
            )}>
              Definir Valor da Negociação
            </p>
          </div>
          <Divider className="col-span-2" />
        </div>
      </React.Fragment>
      {/* <Steps 
    model={interactiveItems} 
    activeIndex={activeIndex}
    onSelect={(e) => {setActiveIndex(e.index);setNegociar(Number(e.index));setReset(prevReset => !prevReset)}} 
    readOnly={false} 
    /> */}
      {negociar ?
        <div className="grid gap-4 mt-2 justify-center w-full">
          <details className="flex-col flex justify-between 
                bg-slate-300 dark:bg-slate-800 pt-4 px-4 
                font-lato-bold w-full dark:border-slate-400
                rounded-lg border-2 border-slate-700
                transition delay-150 duration-300 ease-in-out "
            open={false}>
            <summary className="flex-row flex justify-between cursor-pointer mb-4" >
              <div className="flex flex-row justify-between w-full px-2">
                <h3 className="text-lg text-center font-bold">Selecionar Cobranças</h3>
                <div className="grid">
                  <FaChevronCircleDown
                    className="text-2xl self-center"
                  />
                </div>
              </div>
            </summary>
            <div className=" rounded-md gap-2
            p-4 w-auto grid">
              <div className='flex flex-col text-center'> {/* Checkbox Parcial */}
                <div className='justify-center grid gap-6 text-left mt-3'>
                  <div className="justify-center flex w-full">
                    <SelectButton
                      value={tipoNegociacao}
                      options={tipoNegociacaoOptions}
                      itemTemplate={botaoTipoPagamento}
                      onChange={(e) => {
                        if (!e.value) {
                          // console.log(e.value);
                          return e.value;
                        } else if (e.value === "total") {
                          setTipoNegociacao(e.value);
                          resetaTotal(dadosTabela)
                        } else if (e.value === "parcial") {
                          setTipoNegociacao(e.value);
                          valoresNegociacaoParcial([]);
                        }
                        setCobrancasSelecionadas([]);
                      }}
                    />
                  </div>
                  <DataTable
                    value={cobrancasTabela}
                    paginator
                    first={first}
                    rows={limit}
                    totalRecords={total}
                    onPage={onPage}
                    selectionMode={null}
                    selection={cobrancasSelecionadas}
                    onSelectionChange={(e) => mudaSelecao(e)}
                    showSelectAll={false}
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink "
                    currentPageReportTemplate="Exibindo {first} de {last} do total de {totalRecords}"
                    lazy
                    loading={loading}
                  >
                    <Column
                      style={{ maxWidth: "40px" }}
                      selectionMode="multiple"
                      hidden={tipoNegociacao === "total"}
                    />
                    {cobrancasColunas.map((column, index) => (
                      <Column
                        key={index}
                        header={column.header}
                        field={column.field}
                        // headerStyle={column.header}
                        body={column.body}
                      />
                    ))}
                  </DataTable>
                </div>
              </div>
            </div>
          </details>
          <details className="flex-col flex justify-between 
                bg-slate-300 dark:bg-slate-800 pt-4 px-4 
                font-lato-bold w-full dark:border-slate-400
                rounded-lg border-2 border-slate-700
                transition delay-150 duration-300 ease-in-out "
            open={false}>
            <summary className="flex-row flex justify-between cursor-pointer mb-4" >
              <div className="flex flex-row justify-between w-full px-2">
                <h3 className="text-lg text-center font-bold">Desconto</h3>
                <div className="grid">
                  <FaChevronCircleDown
                    className="text-2xl self-center"
                  />
                </div>
              </div>
            </summary>
            <div className=" rounded-md gap-2
            p-4 w-auto grid">
              <div className='flex flex-col text-center'> {/* Checkbox Desconto */}
                <h6><b>Incidência do Desconto</b></h6>
                <div className='justify-center flex gap-6 text-left mt-3'>
                  <div className="flex flex-col gap-1" >
                    <div className="  ">
                      <Checkbox inputId="VOriginal" checked={original} onChange={e => { setOriginal(e.checked); setReset(prevReset => !prevReset) }} />
                      <label htmlFor="VOriginal"> Valor Original</label>
                    </div>
                    <div>
                      <p><b>{formatCurrency(valorOriginal)}</b></p>
                    </div>
                  </div>
                  {valorJuros > 0 && <div className="flex flex-col gap-1" >
                    <div className=" ">
                      <Checkbox inputId="Juros" checked={juros} onChange={e => { setJuros(e.checked); setReset(prevReset => !prevReset) }} />
                      <label htmlFor="Juros"> Juros</label>
                    </div>
                    <div>
                      <p><b>{formatCurrency(valorJuros)}</b></p>
                    </div>
                  </div>}
                  {valorMulta > 0 && <div className="flex flex-col gap-1" >
                    <div className=" ">
                      <Checkbox inputId="Multa" checked={multa} onChange={e => { setMulta(e.checked); setReset(prevReset => !prevReset) }} />
                      <label htmlFor="Multa"> Multa</label>
                    </div>
                    <div>
                      <p><b>{formatCurrency(valorMulta)}</b></p>
                    </div>
                  </div>}
                  {valorIndice > 0 && <div className="flex flex-col gap-1" >
                    <div className=" ">
                      <Checkbox inputId="Indice" checked={indice} onChange={e => { setIndice(e.checked); setReset(prevReset => !prevReset) }} />
                      <label htmlFor="Indice"> Indice</label>
                    </div>
                    <div>
                      <p><b>{formatCurrency(valorIndice)}</b></p>
                    </div>
                  </div>}
                </div>
              </div>

              <div className='flex flex-col text-center'> {/* Radio Desconto */}
                <h6><b>Tipo de Desconto</b></h6>
                <div className='justify-center flex gap-6 mt-3'>
                  <div className="  ">
                    <RadioButton inputId="Porcentagem" value={true} checked={porcentagem} onChange={e => { setPorcentagem(e.value); setReset(prevReset => !prevReset) }} />
                    <label htmlFor="Porcentagem"> Porcentagem</label>
                  </div>
                  <div className=" ">
                    <RadioButton inputId="Valor" value={false} checked={!porcentagem} onChange={e => setPorcentagem(e.value)} />
                    <label htmlFor="Valor"> Valor</label>
                  </div>
                </div>
              </div>

              <div className="flex flex-col lg:flex-row justify-center gap-1 lg:gap-6"> {/* Inputs Desconto */}
                <div className="flex flex-col gap-2">
                  <h6><b>Valor Corrigido</b></h6>
                  <p className="text-xl">{formatCurrency(valorCorrigido)}</p>
                </div>
                <div className="flex justify-center lg:grid">
                  <FaMinusCircle className="self-center text-2xl" />
                </div>
                <div>
                  <h6><b>Desconto</b></h6>
                  {porcentagem ?
                    <InputNumber
                      value={porcentagemDesconto}
                      max={100}
                      onValueChange={(e) => {
                        calculaDescontoPorcentagem(e.value)
                      }
                      }
                      pt={InputNumberPague}
                      placeholder="% de Desconto para o cliente"
                      id="valor"
                      required
                      suffix=" %"
                      min={0}
                    />
                    :
                    <InputNumber
                      value={desconto}
                      max={maxDesconto}
                      onValueChange={(e) => {
                        const max_desconto_novo = calculaMaxDesconto()
                        if (e.value > max_desconto_novo) {
                          setDesconto(max_desconto_novo);
                          const valor_desconto_servicos = valorFeeProtesto - recalculaFeeDesconto(max_desconto_novo);
                          const valor_com_desconto = Math.ceil((valorTotal - max_desconto_novo - valor_desconto_servicos)*100);
                          setValorComDesconto(Math.abs(valor_com_desconto/100));
                        }
                        else {
                          setDesconto(e.value);
                          const valor_desconto_servicos = valorFeeProtesto - recalculaFeeDesconto(e.value);
                          const valor_com_desconto = Math.ceil((valorTotal - e.value - valor_desconto_servicos)*100);
                          setValorComDesconto(Math.abs(valor_com_desconto/100));
                        }
                        setParcela(0);
                        setValorParcela(0);
                        setValorAPagar(0);
                        setTaxaPague(0);
                        setTaxaPagueEntrada(0);
                      }
                      }
                      pt={InputNumberPague}
                      placeholder="Valor do Desconto para o cliente"
                      id="valor"
                      required
                      mode="currency"
                      currency="BRL"
                      locale="pt-BR"
                      min={0}
                    />}
                </div>
                <div className="flex justify-center lg:grid">
                  <FaPlusCircle className="self-center text-2xl" />
                </div>
                <div className="flex flex-col gap-2">
                  <h6><b>Valor Serviços</b></h6>
                  <p className="text-xl">{formatCurrency(valorFeeProtestoDesconto)}</p>
                </div>
                <div className="flex justify-center lg:grid">
                  <FaEquals className="self-center text-2xl" />
                </div>
                <div className="flex flex-col gap-2">
                  <h6><b>Valor c/ Desconto</b></h6>
                  <p className="text-xl">{formatCurrency(valorComDesconto)}</p>
                </div>
              </div>
            </div>
          </details>
          <details className="flex-col flex justify-between 
                bg-slate-300 dark:bg-slate-800 pt-4 px-4 
                font-lato-bold w-full dark:border-slate-400
                rounded-lg border-2 border-slate-700
                transition delay-150 duration-300 ease-in-out "
            open={false}>
            <summary className="flex-row flex justify-between cursor-pointer mb-4" >
              <div className="flex flex-row justify-between w-full px-2">
                <h3 className="text-lg text-center font-bold">Entrada</h3>
                <div className="grid">
                  <FaChevronCircleDown
                    className="text-2xl self-center"
                  />
                </div>
              </div>
            </summary>
            <div className=" rounded-md
            p-4 w-auto grid">
              <div className="flex flex-col lg:flex-row justify-center gap-1 lg:gap-6"> {/* Inputs Entrada */}
                <div className="flex flex-col ">
                  <h6><b>Valor</b></h6>
                  <InputNumber
                    value={valorEntrada}
                    max={valorCorrigido}
                    onValueChange={(e) => {
                      setValorEntrada(e.value);
                      setValorFeeEntrada(calculaFeeEntrada(e.value));
                      setTaxaPagueEntrada(0);
                      setParcela(0);
                      setValorParcela(0);
                      setValorAPagar(0);
                      setTaxaPague(0);
                    }
                    }
                    pt={InputNumberPague}
                    placeholder="Valor de entrada"
                    id="entrada"
                    required
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                    min={0}
                  />
                </div>
                <div className="flex justify-center lg:grid">
                  <FaPlusCircle className="self-center text-2xl" />
                </div>
                <div className="flex flex-col gap-2">
                  <h5><b>Taxa Administrativa</b></h5>
                  <p className="text-xl">{taxaPagueEntrada > 0 ? formatCurrency(taxaPagueEntrada) : '-'}</p>
                </div>
                <div className="flex justify-center lg:grid">
                  <FaPlusCircle className="self-center text-2xl" />
                </div>
                <div className="flex flex-col gap-2">
                  <h5><b>Taxa Envio Protesto</b></h5>
                  <p className="text-xl">{valorTaxaEnvioProtesto > 0 ? formatCurrency(valorTaxaEnvioProtesto) : '-'}</p>
                </div>
                <div className="flex justify-center lg:grid">
                  <FaEquals className="self-center text-2xl" />
                </div>
                <div className="flex flex-col gap-2">
                  <h5><b>Valor Boleto Entrada</b></h5>
                  <p className="text-xl">{(valorEntrada > 0 && valorParcela > 0) ? formatCurrency(valorEntrada + taxaPagueEntrada + valorTaxaEnvioProtesto) : '-'}</p>
                </div>
              </div>
            </div>
          </details>
          <div className=" rounded-md bg-slate-200 dark:bg-slate-700
          p-4 w-auto grid  gap-2">
            <h3 className="text-lg text-center font-bold">Parcelamento</h3>
            <div className="flex flex-col lg:flex-row justify-center gap-1 lg:gap-6"> {/* Parcelamento */}
              <div>
                <h6><b>Dia Vencimento Boleto</b></h6>
                <Calendar
                  value={addDays(new Date(), vencimentoBoleto)}
                  min={new Date()}
                  locale="pt-BR"
                  dateFormat="dd/mm/yy"
                  onChange={(e) => { setVencimentoBoleto(differenceInDays(e.value, set(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 }))) }}
                  placeholder="ex: 25/05/2024"
                  pt={CalendarPague}
                  //yearRange="1900:2030"
                  showOnFocus={false}
                  showIcon
                  icon={<FaCalendarAlt className={
                    classNames('px-4 rounded-r-lg',
                      'w-[50px] h-full',
                      'bg-sky-400 text-white hover:bg-sky-500',
                      'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                    )}
                  />}
                  id="vencimento"
                  required
                  mask="99/99/9999"
                />
              </div>
              <div>
                <h6><b>Nº de Parcelas</b></h6>
                <Dropdown
                  pt={DropdownPague}
                  options={parcelasOpcoes}
                  value={parcela}
                  onChange={(e) => simulaParcelas(e.value)}
                />
              </div>
              <div>
                <h6><b>Valor Parcela</b></h6>
                {!loading ?
                  <p className="text-xl">{formatCurrency(valorParcela)}</p>
                  :
                  <i className="pi pi-spin pi-spinner" style={{ fontSize: "2em" }}></i>
                }
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row justify-center gap-2 lg:gap-6 mt-2"> {/* Resultado */}
            <div className="flex flex-col ">
              <h5><b>Taxa Administrativa</b></h5>
              <p className="text-2xl">{taxaPague > 0 ? formatCurrency(taxaPague) : '-'}</p>
            </div>
            <div className="flex flex-col">
              <h5><b>Valor Total a Pagar</b></h5>
              <p className="text-2xl">{formatCurrency(valorAPagar)}</p>
            </div>
          </div>
          <div className="flex justify-center gap-1">
            <Button
              label={mostraDownloadBoleto ? "Baixar 1º Boleto" : "Gerar Negociação"}
              onClick={() => { mostraDownloadBoleto ? baixaBoleto() : confirmarNegociacao() }}
              loading={loading}
              disabled={valorAPagar === 0}
              className="w-full lg:w-1/3 xl:w-1/3"
              icon={mostraDownloadBoleto ? <FaDownload /> : <FaHandshake />}
            />
            {termoBase64 !== null && <Button
              label="Baixar Termo"
              className="w-full lg:w-1/3 xl:w-1/3"
              severity="danger"
              icon={<FaFilePdf />}
              disabled={valorTotal === 0}
              onClick={() => Base64ToPDF(termoBase64, `Termo_${format(new Date(), 'dd-MM-yyyy')}`)}
            />}
          </div>
        </div>
        :
        <div className="mt-4">
          <h4 className="text-lg text-center"><b>Consumidor:</b> {rowInfo.usuario_nome}</h4>
          <div className="flex flex-col md:flex-row justify-center align-center flex-wrap">
            <div className="w-full mt-4 md:w-1/2">
              <h5><b>Títulos em atraso</b></h5>
              <DataTable
                value={cobrancasTabela}
                paginator
                first={first}
                rows={limit}
                totalRecords={total}
                onPage={onPage}
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink "
                currentPageReportTemplate="Exibindo {first} de {last} do total de {totalRecords}"
                lazy
                loading={loading}
              >
                {cobrancasColunas.map((column, index) => (
                  <Column
                    key={index}
                    header={column.header}
                    field={column.field}
                    // headerStyle={column.header}
                    body={column.body}
                  />
                ))}
              </DataTable>
            </div>
            <div className="flex mt-8 flex-col gap-4 
            w-full md:w-1/2 text-center">
              <h5 className="text-xl"><b>Composição da inadimplência</b></h5>
              <h5 className="text-xl"><b>Valor Original:</b> {formatCurrency(valorOriginal)}</h5>
              {valorJuros > 0 && <h6><b>Valor Juros:</b> {formatCurrency(valorJuros)}</h6>}
              {valorMulta > 0 && <h6><b>Valor Multa:</b> {formatCurrency(valorMulta)}</h6>}
              {valorIndice > 0 && <h6><b>Valor Indice:</b> {formatCurrency(valorIndice)}</h6>}
              <h5 className="text-xl"><b>Valor Corrigido:</b> {formatCurrency(valorCorrigido)}</h5>
              {valorFeeProtesto > 0 && <h6><b>Valor Serviços:</b> {formatCurrency(valorFeeProtesto)}</h6>}
              <h5 className="text-xl"><b>Valor Total:</b> {formatCurrency(valorTotal)}</h5>
              <div className="grid w-full justify-center">
                <Button
                  label="Ir para Negociação"
                  icon={<FaHandshake />}
                  disabled={valorTotal === 0}
                  onClick={() => { setNegociar(true); setActiveIndex(1); setReset(prevReset => !prevReset) }}
                />
              </div>
            </div>
          </div>
        </div>}
    </Dialog>
  )
}